import _ from 'lodash';
import VError from 'verror';

import { actions } from './reducer';
import notify from 'utils/notify';
import UserActions from 'states/resources/users/actions';
import { graphqlRequest } from 'utils/http/redux';

const initMw = () => ({ dispatch, getState }) => next => async action => {
    const nextAction = next(action);

    if (action.type === actions.init.type) {
        const organizationIds = action?.payload?.organizationIds;
        const showAllSS = action?.payload?.showAllSS;

        try {
            let query;
            query = `
                query getOverviewAdData($adsLiveFilters: AdsFilters, $adsUpcomingFilters: AdsFilters, $adsEndedFilters: AdsFilters, $liveCampaignsFilters: LiveCampaignsFilters, $campaignsUpcomingFilters: CampaignsFilters, $campaignsEndedFilters: CampaignsFilters, $alertsFilters: AlertsFilters) {
                    adsEndingSoon: ads(filters: $adsLiveFilters) {
                        id
                        name
                        assigneeId
                        start
                        end
                        timezone
                        fta {
                            enabled
                        }
                        notes
                        metadata {
                            adId
                            progress {
                              progressData {
                                  idealDelivered
                                  currentDelivered
                                  currentPacing
                                  currentStatus
                                  projectedDelivery
                                  projectedPacing
                                  projectedStatus
                                  deliveredToday
                                  deliveredYesterday
                                  deliveredTwoDaysAgo
                                  deliveredThreeDaysAgo
                                  health
                                  totalTarget
                                  goal
                                  revenueAtRisk
                                  goalAtRisk
                              }
                          }
                          metrics {
                            impressions
                            clicks
                            ctr
                            owner_total_media_cost_local_ecpm
                          }
                        }
                        creativeChannels
                        primary_pacing
                        billing_enabled
                        campaignName
                        campaignId
                        type
                        organization
                        assigneeName
                    }
                    upcomingAds: ads(filters: $adsUpcomingFilters) {
                        id
                        name
                        assigneeId
                        start
                        end
                        timezone
                        primary_pacing
                        campaignName
                        campaignId
                        type
                        notes
                        fta {
                            enabled
                        }
                        creativeChannels
                        metadata {
                            progress {
                                progressData {
                                    totalTarget
                                    goal
                                    health
                                }
                            }
                        }
                        organization
                        assigneeName
                    }
                    recentlyEndedAds: ads(filters: $adsEndedFilters) {
                        id
                        name
                        assigneeId
                        start
                        end
                        timezone
                        fta {
                            enabled
                        }
                        notes
                        metadata {
                            adId
                            progress {
                              progressData {
                                  idealDelivered
                                  currentDelivered
                                  currentPacing
                                  currentStatus
                                  projectedDelivery
                                  projectedPacing
                                  projectedStatus
                                  deliveredToday
                                  deliveredYesterday
                                  deliveredTwoDaysAgo
                                  deliveredThreeDaysAgo
                                  health
                                  totalTarget
                                  goal
                                  revenueAtRisk
                                  goalAtRisk
                                  result
                                  deliveredRatio
                                  variance
                              }
                          }
                          metrics {
                            impressions
                            clicks
                            ctr
                            owner_total_media_cost_local_ecpm
                          }
                        }
                        creativeChannels
                        primary_pacing
                        campaignName
                        campaignId
                        type
                        organization
                        assigneeName
                    }
                    campaignsEndingSoon: liveCampaigns(filters: $liveCampaignsFilters) {
                        id
                        name
                        creatorId
                        start
                        end
                        budget_allocation_method
                        revenueModel
                        total_billings_local
                        campaign_max_total_spend
                        type
                        default_timezone
                        flightPacingStrategy
                        ftaEnabled
                        notes
                        creativeChannels
                        organization
                        assigneeName
                        metadata {
                          progressData {
                              idealDelivered
                              currentDelivered
                              currentStatus
                              currentPacing
                              projectedDelivery
                              projectedPacing
                              projectedStatus
                              deliveredToday
                              deliveredYesterday
                              deliveredTwoDaysAgo
                              deliveredThreeDaysAgo
                              goal
                              totalTarget
                              revenueAtRisk
                              spendAtRisk
                              health
                          }
                          metrics {
                            impressions
                            clicks
                            ctr
                            owner_total_media_cost_local_ecpm
                          }
                       }
                       flights(runTime: "live") {
                            id
                            name
                            start
                            end
                            metadata {
                                progressData {
                                    idealDelivered
                                    currentDelivered
                                    currentStatus
                                    currentPacing
                                    projectedDelivery
                                    projectedPacing
                                    projectedStatus
                                    deliveredToday
                                    deliveredYesterday
                                    deliveredTwoDaysAgo
                                    deliveredThreeDaysAgo
                                    goal
                                    totalTarget
                                    revenueAtRisk
                                    spendAtRisk
                                    health
                                }
                                metrics {
                                    impressions
                                    clicks
                                    ctr
                                    owner_total_media_cost_local_ecpm
                                }
                            }
                       }
                    }
                    campaignsUpcoming: campaigns(filters: $campaignsUpcomingFilters) {
                        id
                        name
                        creatorId
                        start
                        end
                        budget_allocation_method
                        revenueModel
                        total_billings_local
                        campaign_max_total_spend
                        type
                        default_timezone
                        flightPacingStrategy
                        ftaEnabled
                        notes
                        creativeChannels
                        organization
                        assigneeName
                        notes
                        metadata {
                          progressData {
                              totalTarget
                              goal
                              health
                          }
                        }
                        flights(runTime: "upcoming") {
                            id
                            name
                            start
                            end
                            metadata {
                                progressData {
                                    goal
                                    totalTarget
                                    health
                                }
                            }
                        }
                    }
                    campaignsEnded: campaigns(filters: $campaignsEndedFilters) {
                        id
                        name
                        creatorId
                        start
                        end
                        budget_allocation_method
                        revenueModel
                        total_billings_local
                        campaign_max_total_spend
                        type
                        default_timezone
                        flightPacingStrategy
                        ftaEnabled
                        notes
                        creativeChannels
                        organization
                        assigneeName
                        metadata {
                          progressData {
                              idealDelivered
                              currentDelivered
                              currentStatus
                              currentPacing
                              projectedDelivery
                              projectedPacing
                              projectedStatus
                              deliveredToday
                              deliveredYesterday
                              deliveredTwoDaysAgo
                              deliveredThreeDaysAgo
                              goal
                              totalTarget
                              revenueAtRisk
                              spendAtRisk
                              result
                              deliveredRatio
                              variance
                              health
                          }
                          metrics {
                            impressions
                            clicks
                            ctr
                            owner_total_media_cost_local_ecpm
                          }
                       }
                       flights(runTime: "ended") {
                            id
                            name
                            start
                            end
                            metadata {
                                progressData {
                                    idealDelivered
                                    currentDelivered
                                    currentStatus
                                    currentPacing
                                    projectedDelivery
                                    projectedPacing
                                    projectedStatus
                                    deliveredToday
                                    deliveredYesterday
                                    deliveredTwoDaysAgo
                                    deliveredThreeDaysAgo
                                    goal
                                    totalTarget
                                    revenueAtRisk
                                    spendAtRisk
                                    result
                                    deliveredRatio
                                    variance
                                    health
                                }
                            }
                       }
                    }
                    alerts: alerts(filters: $alertsFilters) {
                      id
                      campaignId
                      resourceId
                      severity
                      resourceType
                      alertType
                  }
                }
            `;

            const adFilterBase = { organizationIds, showAllSS, hideArchived: true };

            const variables = {
                adsLiveFilters: { ...adFilterBase, runTime: 'live' },
                adsUpcomingFilters: { ...adFilterBase, runTime: 'upcoming' },
                adsEndedFilters: { ...adFilterBase, runTime: 'ended' },
                liveCampaignsFilters: { organizationIds, showAllSS },
                campaignsUpcomingFilters: { runTime: 'upcoming', organizationIds, showAllSS },
                campaignsEndedFilters: { runTime: 'ended', organizationIds, showAllSS },
                alertsFilters: { organizationIds, showAllSS },
            };

            const response = await dispatch(
                graphqlRequest({
                    query,
                    variables,
                })
            );

            const {
                data: {
                    adsEndingSoon,
                    upcomingAds,
                    recentlyEndedAds,
                    campaignsEndingSoon,
                    campaignsUpcoming,
                    campaignsEnded,
                    alerts,
                },
            } = response;

            dispatch(
                actions.initSuccess({
                    endingSoon: adsEndingSoon,
                    upcoming: upcomingAds,
                    recentlyEnded: recentlyEndedAds,
                    campaignsEndingSoon,
                    campaignsUpcoming,
                    campaignsEnded,
                    alerts,
                })
            );
        } catch (error) {
            const organization = _.get(getState(), 'profile.organizationId');
            const user = _.get(getState(), 'profile.userId');

            dispatch(actions.initError({ error }));

            notify({
                error: new VError(error, 'failed to fetch ads in dashboard'),
                metaData: {
                    organization,
                    user,
                },
            });
        }
    }

    if (action.type === actions.fetchSelfServeOrgList.type) {
        try {
            const query = `
                query getSelfServeOrgs {
                    selfServeOrganizations {
                        id
                        name
                    }
                }
            `;

            const {
                data: { selfServeOrganizations },
            } = await dispatch(
                graphqlRequest({
                    query,
                })
            );

            dispatch(
                actions.fetchSelfServeOrgListSuccess({
                    selfServeOrgList: selfServeOrganizations,
                })
            );
        } catch (error) {
            const organization = _.get(getState(), 'profile.organizationId');
            const user = _.get(getState(), 'profile.userId');

            notify({
                error: new VError(error, 'failed to fetch self serve orgs'),
                metaData: {
                    organization,
                    user,
                },
            });
        }
    }

    return nextAction;
};

const userPreferenceMw = () => ({ dispatch, getState }) => next => async action => {
    next(action);

    if (action.type === actions.fetchUserPreference.type) {
        try {
            const query = `
              query getUser {
                    ownUser {
                        _etag
                        preferences{
                            columnPreferencesOnDashboardOverviewPage {
                                hiddenColumns {
                                    live
                                    upcoming
                                    ended
                                }
                                sortBy {
                                    live {
                                        id
                                        desc
                                    }
                                    upcoming {
                                        id
                                        desc
                                    }
                                    ended {
                                        id
                                        desc
                                    }
                                }
                                assigneeFilter {
                                    live
                                    upcoming
                                    ended
                                }
                                organizationFilters
                            }
                        }
                    }
                }
            `;
            const {
                data: {
                    ownUser: {
                        preferences: {
                            columnPreferencesOnDashboardOverviewPage: {
                                hiddenColumns,
                                sortBy,
                                assigneeFilter,
                                organizationFilters,
                            },
                        },
                        _etag,
                    },
                },
            } = await dispatch(
                graphqlRequest({
                    query,
                })
            );

            const selectedOrganizationIds = organizationFilters || [];

            dispatch(
                actions.fetchUserPreferenceSuccess({
                    etag: _etag,
                    hiddenColumns,
                    sortBy,
                    assigneeFilter,
                    organizationFilter: selectedOrganizationIds,
                })
            );

            return selectedOrganizationIds;
        } catch (error) {
            const organization = _.get(getState(), 'profile.organizationId');
            const user = _.get(getState(), 'profile.userId');

            dispatch(actions.fetchUserPreferenceError());

            notify({
                error: new VError(error, 'failed to fetch user preferences'),
                metaData: {
                    organization,
                    user,
                },
            });
        }
    }

    if (action.type === actions.saveUserPreference.type) {
        const userId = _.get(getState(), `profile.userId`);
        const impersonatorId = _.get(getState(), `profile.impersonatorsToken.user.id`);
        const overviewPreferences = _.get(getState(), 'overviewDashboardv2');
        const submittedPreferences = _.cloneDeep({
            hiddenColumns: overviewPreferences.hiddenColumns,
            sortBy: overviewPreferences.sortBy,
            assigneeFilter: overviewPreferences.assigneeFilter,
            organizationFilter: overviewPreferences.organizationFilter,
        });

        if (impersonatorId === userId) {
            const payload = {
                preferences: {
                    columnPreferencesOnDashboardOverviewPage: {
                        hiddenColumns: submittedPreferences.hiddenColumns,
                        sortBy: submittedPreferences.sortBy,
                        assigneeFilter: submittedPreferences.assigneeFilter,
                        organizationFilters: submittedPreferences.organizationFilter,
                    },
                },
            };

            try {
                const updatedUser = await dispatch(
                    UserActions.update(userId, payload, overviewPreferences.etag)
                );
                dispatch(
                    actions.saveUserPreferenceSuccess({
                        etag: updatedUser?._etag,
                        savedPreferences: submittedPreferences,
                    })
                );
            } catch (error) {
                dispatch(actions.saveUserPreferenceError());

                notify({
                    error: new VError(error, 'failed to save dashboard preferences'),
                    metaData: {
                        organization: _.get(getState(), 'profile.organizationId'),
                        user: userId,
                    },
                });
            }
        } else {
            dispatch(actions.saveUserPreferenceError());
        }
    }
};

const alertMw = ({ debounceFn }) => ({ dispatch }) => next => async action => {
    next(action);

    if (action.type === 'ALERT:CREATED' || action.type === 'ALERT:DEACTIVATED') {
        debounceFn(dispatch);
    }

    if (action.type === actions.fetchSidebarAlerts.type) {
        try {
            const { showAllSS, resourceIds, campaignIds } = action.payload;
            const query = `
                    query getOverviewAdData($alertsFilters: AlertsFilters) {
                        alerts: alerts(filters: $alertsFilters) {
                            id
                            campaignId
                            resourceName
                            resourceType
                            resourceId
                            severity
                            body
                            title
                            start
                            alertType
                        }
                    }
                `;

            const response = await dispatch(
                graphqlRequest({
                    query,
                    variables: {
                        alertsFilters: {
                            resourceIds,
                            campaignIds,
                            showAllSS,
                        },
                    },
                })
            );

            dispatch(actions.fetchSidebarAlertsSuccess(response.data.alerts));
        } catch (error) {
            dispatch(actions.fetchSidebarAlertsError(error));
        }
    }
};

export const makeMiddlewares = deps => {
    return [initMw(deps), userPreferenceMw(deps), alertMw(deps)];
};

export const middlewares = makeMiddlewares({
    debounceFn: dispatch => _.debounce(() => dispatch(actions.init()), 15000),
});
